import { SelectionAction, ActionType } from '../actions/SelectionAction';

export const enum SelectionType {
  NONE,
  RANGE,
  TEMPORARY,
  MARKER,
}

interface SelectionNoneState {
  type: SelectionType.NONE;
}

interface SelectionRangeState {
  type: SelectionType.RANGE;
  cfi: string;
  text: string;
}

interface SelectionTemporaryState {
  type: SelectionType.TEMPORARY;
  cfi: string;
}

interface SelectionMarkerState {
  type: SelectionType.MARKER;
  id: string;
}

export type SelectionState = SelectionNoneState | SelectionRangeState | SelectionTemporaryState |
  SelectionMarkerState;

export function initSelectionState(): SelectionNoneState { return { type: SelectionType.NONE }; }

export function selection(state: SelectionState, action: SelectionAction) {
  switch (action.type) {
    case ActionType.SET_SELECTION_STATE:
      return action.selectionState;
  }
  return state;
}
